/**  
 * SendTaskRequestService
 * Page/Class name   : SendTaskRequestService
 * Author            :
 * Created Date      : 10-3-2020
 * Functionality     : constructor, componentDidMount , componentWillUnmount, getTweetRecords
 * Purpose           : api service page
**/
import {Component } from 'react';
// import {getEndPoint,getTokenFromLocStorage, callApi} from  '../../common_utilities/commonjsfunc';
// newly added axios
//import axios from 'axios';
import {axiosCustomObj} from '../customisedthirdparty/AxiosCustom';

import {commonJsFuncModule as commonJsObj} from  '../../common_utilities/commonjsfunc';
const callApi = commonJsObj.callApi;
const getTokenFromLocStorage = commonJsObj.getTokenFromLocStorage;



class SendTaskRequestService extends Component {

    
    /**  
     * SendTaskRequestService
     * Function name : constructor
     * Author        :
     * Created Date  : 10-3-2020
     * Purpose       : initializing state
     * Params        : 
    **/
    constructor() {
      super();
      this.state = {
          
      }

      //this.axiosObj = axios;
      this.axiosObj = null;
      
      this.apiEndPoint = commonJsObj.getEndPoint()+'rest/tasks/task_request';
    }

    /**  
     * CreateTaskService
     * Function name : componentDidMount
     * Author        :
     * Created Date  : 6-3-2020
     * Purpose       : life cycle method
     * Params        : 
    **/
    componentDidMount() {
    }

    /**  
     * CreateTaskService
     * Function name : componentWillUnmount
     * Author        :
     * Created Date  : 6-3-2020
     * Purpose       : life cycle method
     * Params        : 
    **/
    componentWillUnmount() {  
    }



    /**  
     * CreateTaskService
     * Function name : createTask
     * Author        :
     * Created Date  : 6-3-2020
     * Purpose       : saveOrgDetail check to provide access token 
     * Params        : paramObj
    **/
    async sendTaskRequest(paramObj){
      this.axiosObj = axiosCustomObj({});
      let taskTypeFlag = paramObj.taskTypeFlag;
      let taskId = paramObj.taskId?paramObj.taskId:"";
      let multiTaskFileId = paramObj.multiTaskFileId?paramObj.multiTaskFileId:"";
      let dataObj  = paramObj.data?paramObj.data:{};

      let accToken = getTokenFromLocStorage();     
      try{
            let urldata =this.apiEndPoint;
            
            if(taskTypeFlag==0){
              // single task
              urldata = urldata+"?taskId="+taskId;
            }else if(taskTypeFlag==1){
              // multi task
              urldata = urldata+"?multitaskFileId="+multiTaskFileId;
            }            

            let headerOptn = {  
              "Content-Type": "application/json",
              "Authorization": accToken
            };          

            let respObj = this.axiosObj.post(urldata,dataObj, {
            headers: headerOptn
            });

            return respObj;
    }
    catch(err){
        console.log("Some error occured===>",err); // TypeError: failed to fetch
    }
      

    }

    
}
export default SendTaskRequestService;